import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const AuthorCCD: IClientComponentDefinition = {
  name: 'WAuthor',
  load: () => import(/* webpackChunkName: 'WAuthor' */ './index'),
}
